export const Pseudonym = (entry, { column }) => {
    const { result } = entry;
    return result.pseudonym.key;
}
